import type { ButtonHTMLAttributes, Ref } from 'react';
import './Button.css';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  loading?: boolean;
  fullWidth?: boolean;
  // React 19 passes `ref` as an ordinary prop to function components — no forwardRef needed —
  // but the prop still has to appear in this type and be applied to the underlying <button> for
  // a caller to reach the real DOM node (e.g. a drop zone that needs `contains()` on it).
  ref?: Ref<HTMLButtonElement>;
}

export const Button = ({
  children,
  variant = 'primary',
  loading = false,
  fullWidth = false,
  disabled,
  className = '',
  ref,
  ...props
}: ButtonProps) => {
  const classes = [
    'btn',
    `btn--${variant}`,
    fullWidth && 'btn--full-width',
    loading && 'btn--loading',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      ref={ref}
      className={classes}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? 'Loading...' : children}
    </button>
  );
};
